<template>
  <div>
    <select v-if="!tagging">
      <option v-if="!defvalue" />
      <option v-if="defvalue">
        {{ defvalue }}
      </option>
      <option v-for="(option, idx) in options" :key="idx">
        {{ option }}
      </option>
    </select>
    <select v-else />
  </div>
</template>

<script>
// Minimal Implementation of selectize for Vue.
// Should be expanded upon to support more functionality

// TODO: refactor this component so it has explicit "modes" e.g. tagging, single select, search single select, search single select with description, etc.
import $ from 'jquery'
// import selectize from 'selectize'

export default {
  props: ['options', 'multiple', 'delimiter', 'placeholder', 'maxItems', 'defvalue', 'create', 'tagging', 'tagoptions', 'tagdefvalues', 'isAudience', 'audienceMap', 'email', 'labelField', 'valueField'],
  data: function () { return { instance: false } },
  mounted: function () {
    var self = this
    var options
    if (self.isAudience) {
      options = self.options.map(function (t) {
        var audObj = { name: t, description: '' }
        if (self.audienceMap[t]) {
          audObj.description = self.audienceMap[t].description || ''
        }
        return audObj
      })
    } else if (self.tagoptions) {
      options = self.tagoptions.map(function (t) { return { name: t } })
    } else {
      options = self.options
    }

    var searchFields = 'text'
    if (this.tagging) searchFields = 'name'
    else if (this.isAudience) searchFields = ['name', 'description']

    var sortField = '$order'
    if (this.isAudience) {
      sortField = [
        {
          field: 'name',
          direction: 'asc'
        },
        {
          field: '$order'
        }
      ]
    }
    var opts = {
      delimiter: self.delimiter || ',',
      create: self.create !== undefined ? self.create : true,
      options: options || [],
      valueField: self.tagoptions || self.isAudience ? 'name' : (self.valueField || null),
      labelField: self.tagoptions || self.isAudience ? 'name' : (self.labelField || null),
      items: self.tagdefvalues || [],
      persist: !self.email,
      placeholder: self.placeholder || '',
      sortField: sortField,
      searchField: searchFields,
      maxItems: self.tagging ? null : self.maxItems || 1,
      render: {
        option: function (item, escape) {
          if (item && item.name) {
            var template = '<div><span>' + item.name + '</span>'
            if (item.description && item.description.length > 0) {
              template += '<br><span v-if="item.description">' + item.description + '</span>'
            }
            template += '</div>'
            return template
          }
        },
        item: function (item, escape) {
          var template = '<div class="item option-wrapper" data-value="' + item.name + '">' + item.name
          if (self.tagging) {
            template += '<span class="remove-tag">x</span>'
          }
          template += '</div>'
          return template
        }
      },
      onInitialize: function () {
        var inst = this.$wrapper[0]
        $(inst).on('click.removetag', '.remove-tag', function handleRemoveTag (e) {
          e.stopPropagation()
          var $this = $(this)
          var tagName = $this.parents('.option-wrapper').attr('data-value')
          self.removeItem(tagName)
        })
      },
      onType: function (str) {
        str || this.$dropdown_content.removeHighlight()
      },
      onChange: function (value) {
        self.$emit('change', value)
        if (value === undefined || value === '') {
          this.$dropdown_content.removeHighlight()
        }
      },
      onOptionAdd: function (value, data) {
        self.$emit('addoption', value)
      },
      onFocus: function () {
        if (!self.tagging) {
          this.clear(true)
        }
      }
    }

    this.instance = $(this.$el).selectize(opts)
  },
  beforeUpdate: function () {
    var newdef = this.tagging ? this.tagdefvalues : this.defvalue
    this.instance[0].selectize.setValue(newdef, true)
  },
  beforeDestroy: function () {
    $(this.$el).off('click.removetag')
  },
  methods: {
    removeItem: function (opt) {
      this.instance[0].selectize.removeItem(opt, false)
      this.instance[0].selectize.refreshOptions(false)
    },
    removeOption: function (opt) {
      this.instance[0].selectize.removeOption(opt)
    },
    updateOption: function (value, data) {
      var that = this
      this.$nextTick(function () {
        that.instance[0].selectize.updateOption(value, data)
      })
    },
    addOption: function (opt) {
      var inst = this.instance[0].selectize
      opt.name = opt.label
      delete opt.label
      inst.addOption(opt)
      this.$nextTick(function () {
        inst.refreshOptions(false)
      })
    },
    reset: function () {
      this.instance[0].selectize.clear()
    }
  }
}
</script>
